import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getServer } from "../../consts";

const deleteUser = createAsyncThunk("user/delete", async function (user) {
  await axios.delete(`${getServer()}users/${user.id}`);
  return user;
});

export { deleteUser };
